export default "__VITE_ASSET__BcB2z8x4__"